import {existingUnits} from 'utilities/helper/existingUnitsOption';

export const initialValues = (wholesaler: IWholesalerAddInfo | undefined) => {
  return {
    existing: wholesaler?.existing ? wholesaler.existing : '',
    existing_unit: wholesaler?.existing_unit
      ? wholesaler.existing_unit
      : existingUnits[0].value?.toString(),
  };
};
